import { gql } from "@apollo/client";
import { ROLE_BASE_FRAGMENT, ROLE_DETAIL_FRAGMENT, ROLE_METADATA_FRAGMENT, RoleResponse } from "./roleFragments";

export type RolesArgs = {
  includeMetadata?: boolean;
  includeDetails?: boolean;
}

export type RolesResponseData = {
  roles: RoleResponse[];
};

export const ROLES_QUERY = gql`
  query RolesQuery(
    $includeMetadata: Boolean! = false
    $includeDetails: Boolean! = false
  ) {
    roles {
      ...RoleBaseFragment
      ...RoleMetadataFragment  @include(if: $includeMetadata)
      ...RoleDetailFragment    @include(if: $includeDetails)
    }
  }
  ${ROLE_BASE_FRAGMENT}
  ${ROLE_DETAIL_FRAGMENT}
  ${ROLE_METADATA_FRAGMENT}
`;
